var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',[_c('b-row',{staticClass:"create_team"},[_c('b-col',{staticClass:"text-left",attrs:{"cols":"8"}},[_c('h4',[_vm._v("Local Time ")])]),_vm._v(" "),_c('b-col',{attrs:{"md":"4"}},[_c('c-switch',{attrs:{"type":"3d","variant":"success","checked":_vm.local_time},on:{"change":function($event){_vm.changeTimeSettings($event)}}})],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12769d8a","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/localTime.vue
// module id = 1272
// module chunks = 1